import React from "react";
import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

const HistoryContext = React.createContext(history);

export default HistoryContext;
